function SubSignals() {
    /// <summary>
    /// <br/>
    /// Author: MWI<br />
    /// Date: 9.10.2015<br />
    /// Copyright ©: EUDT GmbH 2015 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.4 - 13.09.2017                                               *<br />
    /// **********************************************************************<br />
    /// * -better legend handling                                            *<br />
    /// **********************************************************************<br />
    /// **********************************************************************<br />
    /// *** v1.0.4 - 13.10.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - views with percent and units added also for prices              *<br />
    /// **********************************************************************<br />
    /// **********************************************************************<br />
    /// *** v1.0.3 - 09.03.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - theme is now a subtheme of rampOptions + small changes           *<br />
    /// **********************************************************************<br />
    /// *** v1.0.2 - 24.11.2015                                               *<br />      
    /// **********************************************************************<br />
    /// * - removed subTitle and added it to the title                      *<br />
    /// **********************************************************************<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 24.11.2015                                               *<br />
    /// **********************************************************************<br />
    /// * - style changes and small change in data                          *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 9.11.2015                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// * - template from ARF                                                *<br />
    /// **********************************************************************<br />
    /// </summary>
    // the following attributes got set in Charts.SubSignals.SubSignals.vb
    this.data = [];

    this.day = "";

}

SubSignals.prototype = new window.vcTemplate();
SubSignals.prototype.getTheme = function () {
    ///<summary>
    ///gets the theme for the javascript 
    ///</summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.visual.find("#divChart").height(me.visual.height() - me.visual.find("#baseHeader").height());
        me.setTheme();
      
        switch (parseInt(me.deviceType, 10)) {
            case 1:

                return me.theme;
            case 2:

                return me.themeLarge;
        }
        return me.theme;
    } catch (ex) {
        me.writeError('subSignals.js.getTheme', ex);
        return false;
    }

};

SubSignals.prototype.setLabelFormatter = function (me, element) {
    var tooltip;

    try {
        //if (element.name.replace(/<.?i[^><]*> /g, "").length > 120) {
        //    addBreak = "<br />";
        //}

        //if (element.tooltipName) {
        var tmpName = $("<div>" + element.name + "</div>");
        var icons = tmpName.find("i");

        var match = tmpName[0].innerText.match(/.{1,60}/g);
        tooltip = "";
        for (var i = 0; i < icons.length; i++) {
            tooltip += icons[i].outerHTML;
        }
        if (match.length > 1) {
            for (var z = 0; z < match.length-1; z++) {
                tooltip += match[z].toString() + "<br />";
            }
            tooltip += match[match.length - 1].toString();
        } else {
            tooltip += match.toString();
        }
        tooltip = " " + tooltip + " ";
        tooltip += " " + (element.y).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + element.valueSuffix + " - " + element.percentage.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2, minimumIntegerDigits: 2 }) +" % " ;
        return  tooltip;

    } catch (ex) {

        
        me.writeError("subSignals.js.LabelFormatter",ex);
        return "";
    }
};
SubSignals.prototype.setTheme = function () {
    var me = this;
    var rampOpt = new window.RampOptions();
    var bLegend;
    try {
        if (me.width > 900) {
            bLegend = true;
        } else {
            bLegend = false;
        }
        if (me.deviceType ===2) {bLegend = false}

        me.theme = {
            chart: {
                type: 'pie',
                animation: true,
                spacingTop: 10,
                spacingBottom: 10,
                spacingLeft: 10,
                spacingRight: 10,
                // Explicitly tell the width and height of a chart
                width: null,
                height: me.visual.find("#divChart").height()
            },
         
            legend: {
                enabled: bLegend,
                               itemStyle: { "fontSize": "12px", "height": "22px"},
                symbolPadding: 5,
                title: "legend",
                itemDistance: 50,


                navigation: {
                    enabled:true,
                    activeColor: '#3E576F',
                    animation: true,
                    arrowSize: 15,
                    inactiveColor: '#CCC',
                    style: {
                        fontWeight: 'bold',
                        color: '#333',
                        fontSize: '12px'
                    }
                },
                    reversed: false,
                    align: "right",
                    layout: "vertical",
                    verticalAlign: "middle",
                    useHTML: true,
                    labelFormatter: function () {
                        return me.setLabelFormatter(me, this);
                    }

                },
   
            tooltip: {
                enabled: true,
                formatter: function () {
                    return me.setLabelFormatter(me, this.point);
                },
                backgroundColor: "white"
            },
            plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        borderWidth: 0,
                        slicedOffset: 10,
                        cursor: 'pointer',
                        dataLabels: {
                            style: { fontWeight: "normal", fontSize:"13px" },
                            y: 0,
                            enabled: true,
                            format: "{point.percentage:,.2f} %",
                            color: "{point.color}",
                            softConnector: false,
                            connectorWidth: 1,
                            shadow: false,
                            distance: 15
                        },
                        size:me.visual.find("#divChart").height() * 0.8,
                        showInLegend: true,
                        innerSize: 0
                    }
                },
                series: {
                    startAngle: 45,
                    dataLabels: { defer: true, shadow: false },
                    allowPointSelect: true,
                    name: "",
                    innerSize: '0%',
                    states: { hover: { halo: { size: 20 } } }
                }
                //column: { stacking: 'normal' }
        };
     
        me.theme.exporting = {
            enabled: (me.deviceType !== "2"),tableCaption:'',csv: {  columnHeaderFormatter: function(item) {  return rampOpt.generateExportColHeader(item);}},
          
        }


        me.theme = window.Highcharts.merge(rampOpt.getTheme(),me.theme);
        //me.theme = Highcharts.merge(me.theme, me.getTheme());
        var legendWidth = 500;
        if ($("#content_main").length > 0) {
            legendWidth =  parseInt($("#content_main").width() / 3, 10);
        }
        me.themeLarge = window.Highcharts.merge(me.theme, {
            plotOptions: {
                pie: {
                    dataLabels: {
                    
                        style: { fontSize: "18px" }
                    }
                },
                                      size:me.visual.find("#divChart").height() * 0.9

            },
            legend: {
                symbolPadding: 15,
               
                itemStyle: { font: '15px Verdana, helvetica, arial' },
                title: "legend",
                //maxHeight: 600,
                width: legendWidth,
                useHTML: true,
                rtl: false
            } , tooltip: {
                enabled: false
            }
        });

    } catch (ex) {
        me.writeError('subSignals.js.setTheme', ex);
    }
  
};



SubSignals.prototype.init = function () {
    /// <summary>
    /// This function inits the chart. <br/>
    /// </summary>
    var me = this;
 
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);

        me.visual.find("#baseHeader").removeClass("vc-grid-2col").addClass("vc-grid-4col");

        //me.showDevIcon("");
        // Build the chart
        if (me.data.noError) {
            me.visual.find("#divHint").hide();
            if (parseFloat(me.overSupplyValue) > 0) {
                me.visual.find("#baseHeader").append("<div class='icon-color-error' style='font-size:smaller'>" + me.resources.subSignalOverSupplyInfo + " " + me.overSupplyValue.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " [" + me.signalUnit + "]</div>");
              }
         
            me.visual.find(".sankeySignal").html(me.data.title + " - " + me.data.value.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + me.data.unit);
            me.visual.find(".sankeyDate").html(me.data.subtitle);
    
            window.setTimeout(function () {

                var opt = window.Highcharts.merge(me.getTheme(), {
                        chart: {
                            renderTo: "divChart",
                            // Explicitly tell the width and height of a chart
                            width: me.visual.width(),
                            height: me.visual.find("#divChart").height()
                        },
                        series: [{ name: me.data.data.name, data: me.data.data }]
                    }
                )

                me.chart = Highcharts.chart(opt);
                window.__GLOBAL_VISUAL_LIST["subsignal"] = me.chart;
            }, 100);
           

        } else {
            me.visual.find("#info")
                .html("<div class='ui-corner-all ui-state-error' style='padding:10px;margin:10px;text-align:center'>" +me.data.errorText+"</div>").show();
            //me.showInfo(me.data.errorText, "",false);
            $("#baseHeader").hide();
            me.visual.find("#divHint").hide();
        }
        return true;
    } catch (ex) {
        me.writeError('subSignals.js.init', ex);
        return false;
    }

};
SubSignals.prototype.doEvent = function () {
    /// <summary>
    /// The function doEvent is not needed, but to prevent errors set to an empty function 
    /// </summary>
};


SubSignals.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('#divChart, #divContentSub1').hide();
        }
        return true;
    } catch (ex) { 
        me.writeError('subSignals.js.specificInfoHandling', ex);
        return false;
    }
};

